import { getPendoData } from "api/generated/utils/utils";

import { injectPendoScript } from "./injectPendoScript";

/**
 * We need to remove some sensitive data like the password reset token from any collected data for sentry and pendo
 * The password reset token is an uuid serialized to base64, which is what the first regex is looking for. Since the length of an uuid is always the same, we'll always have two == at the end as padding
 * The external id is just an uuid inside the path to the collect screen which we also remove with the second regex
 */
function sanitizeUrl(data: string) {
    return data
        .replaceAll(
            /((?:[A-Za-z0-9\/+]|%2[BF]){22}(?:(?:%3D%3D)|(?:==)))/g,
            "<scrubbed_data>"
        )
        .replaceAll(
            /(\/Collect\/)[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g,
            "$1<scrubbed_data>"
        );
}

export async function initializePendo(apiKey: string) {
    injectPendoScript(apiKey);

    const { data, status } = await getPendoData();

    // Firefox reports a request aborted by a hard navigation as a resolved response with
    // status 0 and an empty "" body — axios' settle() treats the falsy status
    // as success. Bail out: there is nothing to initialise if we are leaving
    // the page, and data.payload would be undefined here. See sc-38969.
    if (status === 0) {
        return;
    }

    pendo.initialize({
        visitor: {
            id: data.pendo_id,
            role: data.payload.roles,
            creationDate: data.payload.created_at,
            culture: data.payload.culture,
        },
        account: {
            id: data.payload.company.id,
            name: data.payload.company.name,
            creationDate: data.payload.company.created_at,
            customerState: data.payload.company.customer_state,
        },
        excludeAllText: true,
        location: { setUrl: () => sanitizeUrl(window.location.href) },
    });
}
